import { api } from "@/config/api";
import * as Sentry from "@sentry/react-native";
import type { AxiosError } from "axios";

import { PlateFailReason, PlateUpdateFailReason } from "ipctg-inflow-types/InFlowEnums";
import type {
  ParkPlatePOSTErrorResponse,
  ParkPlatePOSTRequest,
  ParkPlatePOSTSuccessResponse,
  ParkPlateUpdatePOSTErrorResponse,
  ParkPlateUpdatePOSTRequest,
  ParkPlateUpdatePOSTSuccessResponse,
} from "ipctg-inflow-types/InFlowParkAPI";
import { Platform } from "react-native";

export const fetchPlate = async (requestData: ParkPlatePOSTRequest): Promise<ParkPlatePOSTSuccessResponse> => {
  try {
    const response = await api.post<ParkPlatePOSTSuccessResponse>("/plate", requestData);
    return response.data;
  } catch (error) {
    Sentry.captureException(error, {
      extra: {
        data: requestData,
        localStorage: Platform.OS === "web" ? window.localStorage : null,
      },
    });
    const axiosError = error as AxiosError<ParkPlatePOSTErrorResponse>;
    throw axiosError.response?.data ?? { failReason: PlateFailReason.SystemError };
  }
};

export const updatePlate = async (requestData: ParkPlateUpdatePOSTRequest): Promise<ParkPlateUpdatePOSTSuccessResponse> => {
  try {
    const response = await api.post<ParkPlateUpdatePOSTSuccessResponse>("/plate-update", requestData);
    return response.data;
  } catch (error) {
    Sentry.captureException(error, {
      extra: {
        data: requestData,
        localStorage: Platform.OS === "web" ? window.localStorage : null,
      },
    });
    const axiosError = error as AxiosError<ParkPlateUpdatePOSTErrorResponse>;
    throw axiosError.response?.data ?? { failReason: PlateUpdateFailReason.SystemError };
  }
};
